"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

var _common = require("../../common");

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Collapser =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Collapser, _PureComponent);

  function Collapser(props) {
    var _this;

    _classCallCheck(this, Collapser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collapser).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setInitialHeight", function () {
      var menuHeight = _this.getRefHeight(_this.menuRef);

      var current = _this.wrapperRef.current;

      if (current) {
        current.setAttribute('style', "max-height: ".concat(menuHeight, "px;"));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearTimers", function () {
      if (_this.startTimer) {
        clearTimeout(_this.startTimer);
      }

      if (_this.endTimer) {
        clearTimeout(_this.endTimer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOpenAnimationEnd", function () {
      var current = _this.wrapperRef.current;

      if (current) {
        current.setAttribute('style', 'max-height: none');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnCloseAnimationEnd", function () {
      return _this.setState({
        isActive: false
      }, _this.setInitialHeight);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOpen", function () {
      _this.clearTimers();

      var menuHeight = _this.getRefHeight(_this.menuRef);

      var contentHeight = _this.getRefHeight(_this.contentRef);

      var duration = _this.props.duration;
      var current = _this.wrapperRef.current;

      if (current) {
        current.setAttribute('style', "max-height: ".concat(menuHeight + contentHeight, "px; transition: max-height ").concat(duration, "ms ease-in-out;")); // set animation timer

        _this.startTimer = setTimeout(_this.handleOnOpenAnimationEnd, duration + 1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClose", function (wrapperHeight) {
      _this.clearTimers();

      var duration = _this.props.duration;
      var current = _this.wrapperRef.current; // fix close animation

      if (current) {
        // current height
        current.setAttribute('style', "max-height: ".concat(wrapperHeight, "px"));
        _this.endTimer = setTimeout(function () {
          var menuHeight = _this.getRefHeight(_this.menuRef);

          current.setAttribute('style', "max-height: ".concat(menuHeight, "px; transition: max-height ").concat(duration, "ms ease-in-out;"));
          _this.endTimer = setTimeout(_this.handleOnCloseAnimationEnd, duration + 1);
        }, 1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      var active = _this.state.active;

      if (onChange) {
        onChange(e, {
          name: name,
          value: active
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "open", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation', 'preventDefault');
      var active = _this.state.active;

      if (!active) {
        _this.setState({
          active: true,
          isActive: true
        }, function () {
          _this.handleOnOpen();

          var onOpen = _this.props.onOpen;

          if (onOpen) {
            onOpen(e);
          }

          _this.handleOnChange(e);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "close", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation', 'preventDefault');
      var active = _this.state.active;

      if (active) {
        var wrapperHeight = _this.getRefHeight(_this.wrapperRef);

        _this.setState({
          active: false,
          isActive: true
        }, function () {
          _this.handleOnClose(wrapperHeight);

          var onClose = _this.props.onClose;

          if (onClose) {
            onClose(e);
          }

          _this.handleOnChange(e);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation', 'preventDefault');

      var wrapperHeight = _this.getRefHeight(_this.wrapperRef);

      _this.setState(function (prevState) {
        return {
          active: !prevState.active,
          isActive: true
        };
      }, function () {
        var active = _this.state.active;

        if (active) {
          _this.handleOnOpen();
        } else {
          _this.handleOnClose(wrapperHeight);
        }

        var onToggle = _this.props.onToggle;

        if (onToggle) {
          onToggle(e);
        }

        _this.handleOnChange(e);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var propNames = ['active'];
      var names = [Collapser.className];
      (0, _lib.addClassByPropName)(names, _this.props);
      (0, _lib.addClassByPropName)(names, _this.state, propNames);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "getRefHeight", function (ref) {
      var current = ref.current;

      if (current) {
        var offsetHeight = current.offsetHeight;
        return offsetHeight;
      }

      return 0;
    });

    var _active = props.active;
    _this.state = {
      prevProps: {
        active: _active
      },
      active: false,
      isActive: _active
    };
    _this.contentRef = _react.default.createRef();
    _this.wrapperRef = _react.default.createRef();
    _this.menuRef = _react.default.createRef();
    _this.startTimer = null;
    _this.endTimer = null;
    return _this;
  }

  _createClass(Collapser, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setInitialHeight();
      var active = this.props.active;

      if (active) {
        this.handleOnOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var active = this.props.active;

      if (prevProps.active !== active) {
        this.clearTimers();

        if (active) {
          this.open();
        } else {
          this.close();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          as = _this$props2.as,
          className = _this$props2.className,
          children = _this$props2.children,
          name = _this$props2.name,
          onChange = _this$props2.onChange,
          onOpen = _this$props2.onOpen,
          onClose = _this$props2.onClose,
          onToggle = _this$props2.onToggle,
          propsActive = _this$props2.active,
          wrapperRef = _this$props2.wrapperRef,
          duration = _this$props2.duration,
          rest = _objectWithoutProperties(_this$props2, ["as", "className", "children", "name", "onChange", "onOpen", "onClose", "onToggle", "active", "wrapperRef", "duration"]);

      var _this$state = this.state,
          active = _this$state.active,
          isActive = _this$state.isActive;
      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      var ref = wrapperRef || this.wrapperRef;
      return _react.default.createElement(Wrapper, _extends({}, rest, {
        className: classNames,
        ref: ref
      }), (0, _lib.getRenderProps)(children, {
        open: this.open,
        close: this.close,
        toggle: this.toggle,
        contentRef: this.contentRef,
        menuRef: this.menuRef,
        active: active,
        isActive: isActive
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var active = props.active;
      return {
        // Store the previous props in state
        prevProps: {
          active: active
        },
        active: prevProps.active !== active && state.active === active ? active : state.active,
        isActive: prevProps.active !== active ? true : state.isActive
      };
    }
  }]);

  return Collapser;
}(_react.PureComponent);

exports.default = Collapser;

_defineProperty(Collapser, "className", 'MHub-Collapser');

_defineProperty(Collapser, "propTypes", {
  as: _common.customPropTypes.as,
  className: _propTypes.default.string,
  children: _common.customPropTypes.render.isRequired,
  name: _propTypes.default.string,
  active: _propTypes.default.bool,
  wrapperRef: _common.customPropTypes.ref,
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onToggle: _propTypes.default.func,
  onChange: _propTypes.default.func,
  duration: _propTypes.default.number
});

_defineProperty(Collapser, "defaultProps", {
  as: null,
  className: null,
  active: false,
  name: null,
  wrapperRef: null,
  onOpen: null,
  onClose: null,
  onToggle: null,
  onChange: null,
  duration: 500
});